import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import UPButton from 'components/button';

export const SectionContainer = styled(Box)(() => ({
  marginTop: '48px',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  fontWeight: 600,
  fontSize: 16,
  marginBottom: '16px',
}));

export const AddEmployeeFunctionLinkButton = styled(UPButton)(() => ({
  marginRight: '16px',
}));

export const ModalLayout = styled(Box)(() => ({
  width: '100%',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  background: 'rgb(250, 250, 250)',
  borderRadius: '8px',
  border: 'none',
  maxHeight: '650px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const ModalBody = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
}));

export const ModalActions = styled(Box)(() => ({
  flexShrink: 0,
  backgroundColor: 'white',
  borderTop: '1px solid #e0e0e0',
  padding: '12px 0px',
  display: 'flex',
  gap: '16px',
  justifyContent: 'center',
  borderBottomRightRadius: '8px',
  borderBottomLeftRadius: '8px',
}));
